import React from 'react';
import Image from 'next/image';
import Contactusbg from '../../public/images/cont8.webp';
import Contactuscoman from './contactuscommon';



const Contactpage = () => {
  return (
    <div className='relative contactus_baner' alt="automated recruiting software">
      <Image src={Contactusbg} alt='cv creator' className='h-[125vh] w-full'/>
      <div className='absolute inset-0 flex flex-col text-start'>
        <div className='text-xl font-bold text-[#FF5349] 2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 mt-28'> #WeDriveEasyCampus</div>
      </div>
      <Contactuscoman />
    </div>
  )
}

export default Contactpage